import { LexicalEditor,  TextNode } from "lexical";



function getTextNodeJson(text: string){
    return  ({
        "detail": 0,
        "format": 0,
        "mode": "normal",
        "style": "",
        "text": text,
        "type": "text",
        "version": 1
    })
}

function getLinebreakNodeJson(){
    return ({
        "type": "linebreak",
        "version": 1
    })
}
function getParagraphNodeJson(children: any[]) {
    return ({
        "children": children,
        "direction": "ltr",
        "format": "",
        "indent": 0,
        "type": "paragraph",
        "version": 1,
        "textFormat": 0,
        "textStyle": ""
    });
}

function getRootNodeJson(children: any[]) {
   return  ({
        "root": {
            "children": children,
            "direction": "ltr",
            "format": "",
            "indent": 0,
            "type": "root",
            "version": 1
        }
    });
}


export function ChatEditorToPlaintextBody(editor:LexicalEditor){
    
    const editorState = editor.getEditorState();
    
    let model:any = []
    
    editorState._nodeMap.forEach((node) => {
        if(node.__type === 'text') {
            model.push({plainText:(node as TextNode).__text.trim(), bodyType: 'plainText'})
        }
        else if(node.__type === 'linebreak') {
            model.push({plainText:'\n', bodyType:'plainText'})
        }
    })
    
    return ({
        body: {
            bodyType:'plainText',
            plainText: model.map((el: any) => el.plainText).join('')
        }
    });
}

export function ChatEditorToPlainString(editor:LexicalEditor){
    
    const editorState = editor.getEditorState();
    
    let string = '';
    
    editorState._nodeMap.forEach((node) => {
        if(node.__type === 'text') {
            string += (node as TextNode).__text.trim()
        }
        else if(node.__type === 'linebreak') {
            string += '\n'
        }
    })
    
    return string;
}

export function plainTextBodyToChatEditor(messageBody: any) {

    const paragraphChildren = messageBody.plainText.split('\n').map((pt: string) => {
        if(!pt) {
            return getLinebreakNodeJson()
        }
        else {
            return getTextNodeJson(pt);
        }
    })

    return getRootNodeJson([getParagraphNodeJson(paragraphChildren)])
}